const contentLinks = [
  { label: '今日索引', href: '#index' },
  { label: '热门推荐', href: '#featured' },
  { label: '分区合集', href: '#zones' },
  { label: '独家线索', href: '#leads' },
];

const exchangeLinks = [
  { label: '群组互换', href: '#groups' },
  { label: '线索交换所', href: '#index' },
  { label: '投稿与分享', href: '#join' },
  { label: '入坑指南', href: '#groups' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-10 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-newspaper-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
                黑料网址
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-loose text-foreground-600">
              一个以杂志节奏更新网址分享与线索索引的小站。内容以整理和呈现为主，所有条目都会标注来源与更新时间，方便你自行判断。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-refresh-line"></i> 每日 22:00 更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line"></i> 来源标注
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm tracking-wider text-foreground-950">
              <a href="#index" className="cursor-pointer">
                内容索引
              </a>
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {contentLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm tracking-wider text-foreground-950">
              <a href="#groups" className="cursor-pointer">
                交流互换
              </a>
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {exchangeLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm tracking-wider text-foreground-950">
              <a href="#join" className="cursor-pointer">
                站点说明
              </a>
            </h4>
            <p className="mt-5 text-sm leading-loose text-foreground-600">
              本站为内容索引与交流展示页，不提供任何存储服务，也不对第三方站点内容负责。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 黑料网址 · 分享推荐交流</span>
          <span>本期 第 018 期 · 索引内容每日更新</span>
        </div>
      </div>
    </footer>
  );
}